module.exports = __webpack_public_path__ + "img/鲁河镇.445328ad.png";